<template>
    <router-view></router-view>
</template>

<script>
/* eslint-disable */
import Header from "@/components/header/Header.vue";
import Footer from "@/components/Footer/New-footer.vue";
import BreadCrumb from "@/components/global/My-breadcrumb.vue";

export default {
    components: {
        Header,
        Footer,
        BreadCrumb
    }
}
</script>
